import { createSelector } from 'reselect'

import storeSearchResultsSelector from './store_search_results_selector'
import storeBreadcrumbSelector from './store_breadcrumb_selector'
import qsSearchQuerySelector from 'redux/selectors/qs/qs_search_query_selector'
import shouldHideStoreSelector from 'redux/selectors/user/user_store_access_selector'
import userCannySelector from 'redux/selectors/user/user_canny_selector'
import userPermissionsSelector from 'redux/selectors/user/user_permissions_selector'
import userShouldSeeFeedbackBoxSelector from 'redux/selectors/user/user_should_see_feedback_box'

import searchStatuses from 'helpers/enums/storeSearchStatuses'
import viewTypes from 'helpers/enums/viewTypes'

const getStore = state => state.store
const getUI = state => state.ui
const getCart = state => state.cart

const storeSearchContainerSelector = createSelector(
	[
		getStore,
		getUI,
		qsSearchQuerySelector,
		storeSearchResultsSelector,
		storeBreadcrumbSelector,
		getCart,
		shouldHideStoreSelector,
		userCannySelector,
		userPermissionsSelector,
		userShouldSeeFeedbackBoxSelector,
	],
	(
		storeData,
		uiData,
		qsData,
		resultsData,
		breadcrumbData,
		cartData,
		shouldHideStore,
		cannyProperties,
		permissions,
		shouldSeeFeedbackBox,
	) => {
		const showNoResultsMessage = storeData.searchStatus === searchStatuses.READY && storeData.results.length === 0
		const hasMoreResults = storeData.hasMoreResults && storeData.searchStatus === searchStatuses.READY && storeData.results.length !== 0
		const showLoadingMore = storeData.searchStatus === searchStatuses.LOADING_MORE
		const lessons = resultsData.lessons.map(lesson => (
			{
				...lesson,
				data: {
					...lesson.data,
					isAddingToCart: cartData.adding.includes(lesson.data.entityUID),
				},
			}
		))

		let hasStoreAccess = !shouldHideStore
		const isCreationVideoView = uiData.currentView === viewTypes.VIDEO_CREATE
			|| uiData.currentView === viewTypes.INTERACTIVE_VIDEO_CREATE
		if (hasStoreAccess && isCreationVideoView && permissions.isLoaded) {
			hasStoreAccess = permissions.hasAccessToVideoLessonsFromStore
		}

		return {
			query: storeData.query,
			showLoadingMore,
			currentSearchQuery: qsData,
			container_width: uiData.width,
			hasMoreResults,
			showNoResultsMessage,
			lessons,
			useGridPadding: resultsData.useGridPadding,
			breadcrumbFilters: breadcrumbData.breadcrumbFilters,
			showPriceThumb: resultsData.showPriceThumb,
			shouldHideStore: !hasStoreAccess,
			cannyProperties,
			shouldShowFeedbackBox: shouldSeeFeedbackBox,
		}
	}
)

export default storeSearchContainerSelector
